module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwCAYAAABE1blzAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACISURBVHgB7dfBCYAwEAXRjViYrViZrdiZbgXJYQk6Yd41isxByG9R9KTeeUsx0ej7WyzOQDoD6QykM5DOQDoD6fb4WI6Bq3eeY+SMgvKUqc6l2e/7D9IZSGcgnYF0BtIZSLfnXfXoPZB33TvA2t/XgGtiwEA6A+kMpDOQzkA6A+kMpDOQbvnAFy5bLFaTETdLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/performance-icon.png
// module id = 339
// module chunks = 1